// src/utils/format.js

/**
 * Convert bytes to human-readable format
 * @param {number} bytes
 * @returns {string}
 */
export function bytesToSize(bytes) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / (1024 ** i);
  return `${value.toFixed(2)} ${sizes[i]}`;
}

/**
 * Format a storage amount given in GB, switching to TB from 1000 GB
 * @param {number} gb
 * @returns {string}
 */
export function gbToSize(gb) {
  if (gb >= 1000) return `${parseFloat((gb / 1000).toFixed(2))} TB`;
  return `${gb} GB`;
}
